import { AnalyticsTag } from '@/shared/api/transcriptor/transcriptorApi';

export type AnalyticsTagGroup = {
  code: string;
  name: string;
  tags: AnalyticsTag[];
};

const appendTagToGroup = (
  groups: AnalyticsTagGroup[],
  tag: AnalyticsTag,
): AnalyticsTagGroup[] => {
  const groupIndex = groups.findIndex((group) => group.code === tag.group_code);

  if (groupIndex === -1) {
    return [
      ...groups,
      {
        code: tag.group_code,
        name: tag.group_name?.trim() || tag.group_code,
        tags: [tag],
      },
    ];
  }

  return groups.map((group, index) =>
    index === groupIndex ? { ...group, tags: [...group.tags, tag] } : group,
  );
};

export const groupTagsByGroupCode = (
  tags: AnalyticsTag[],
): AnalyticsTagGroup[] =>
  tags.reduce<AnalyticsTagGroup[]>(appendTagToGroup, []);
